import styled from 'styled-components';
import {
  container,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding-right: ${spacing('md')};
  padding-left: ${spacing('md')};
  text-align: center;
`;

export const StyledImage = styled.div`
  img {
    display: block;
    margin: auto;
  }
`;

export const StyledTitle = styled.h4`
  font-family: inherit;
  font-weight: ${fontWeight('extrabold')};
  font-size: ${fontSize('xl')};
  line-height: 1.16;
  margin-top: 0;
  margin-bottom: ${spacing('lg')};

  @media (min-width: ${screen('md')}) {
    font-size: ${fontSize('xl3')};
    line-height: 1.125;
    margin-top: ${spacing('md')};
  }
`;
